module.exports = __webpack_public_path__ + "static/media/man-in-coat.657d4137.jpg";